import React from 'react';
import { Highlight } from './Highlight';
import { MockWindow } from './MockWindow';
const plans = [{
  name: 'Standard',
  price: '$0.05 per screened transaction',
  recommended: true
}, {
  name: 'Plus',
  price: '$0.07 per screened transaction',
  recommended: false
}, {
  name: 'Pro',
  price: '$0.09 per screened transaction',
  recommended: false
}];
export function FraudMockup() {
  return <MockWindow data-id="element-83" data-mp="3q5mukcp0g5oa">
      <div className="px-[3cqw] py-[2cqw]" data-id="element-84" data-mp="3q54pqroa8j4r">
        <div className="w-[28cqw]" data-id="element-85" data-mp="3q890y9060f4x">
          <p className="text-[1.5cqw] font-semibold text-mm-black" data-id="element-86" data-mp="3l7l1r01s8rzm">Protect your business from fraud</p>
          <p className="mt-[0.4cqw] text-[1cqw] text-mm-mid-gray" data-id="element-87" data-mp="3zhh9ln5g79r">
            Choose the level of protection for your business.
          </p>
          <ul className="mt-[1.2cqw] flex flex-col gap-[0.6cqw]" data-id="element-88" data-mp="3v60rozp2pv7j">
            {plans.map(plan => <li key={plan.name} className={`relative px-[1cqw] py-[0.7cqw] ${plan.recommended ? 'border-[0.15cqw] border-[#635BFF]' : 'border border-mm-light-gray'}`} data-id="element-89" data-mp="25qkvsm05u5zl">
                {plan.recommended ? <span className="absolute -top-[1cqw] left-[0.8cqw] bg-[#635BFF] px-[0.5cqw] text-[0.9cqw] font-semibold leading-[1.6] text-white" data-id="element-90" data-mp="1eutlf738frtu">
                    Recommended
                  </span> : null}
                <p className={`text-[1.05cqw] font-semibold ${plan.recommended ? 'text-[#635BFF]' : 'text-mm-charcoal'}`} data-id="element-91" data-mp="1tjg9bx6xdrwo">
                  {plan.name}
                </p>
                <p className="text-[1cqw] text-mm-mid-gray" data-id="element-92" data-mp="22lftgyd8lc3u">{plan.price}</p>
              </li>)}
          </ul>
          <Highlight tone="stop" tag="Not this" className="mt-[1.4cqw]" data-id="element-93" data-mp="27ifx72mm62rs">
            <div className="flex h-[2.4cqw] items-center justify-center bg-[#635BFF] text-[1.05cqw] font-semibold text-white" data-id="element-94" data-mp="87ev0ellmr4a">
              Continue with Standard
            </div>
          </Highlight>
          <div className="mt-[1.1cqw] flex justify-center" data-id="element-95" data-mp="1ggwypr0fa8dx">
            <Highlight tone="go" tag="YES, click this" data-id="element-96" data-mp="1bhajxd4y4k30">
              <span className="text-[1cqw] text-mm-charcoal underline" data-id="element-97" data-mp="1bivcix7p9sy8">
                Use baseline protection with Lite (included)
              </span>
            </Highlight>
          </div>
        </div>
      </div>
    </MockWindow>;
}